module.exports = __webpack_public_path__ + "static/media/fire_scroll.a98e3925.png";